import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { Task, CreateTaskData, UpdateTaskData } from '../../../types/task';
import { TaskForm } from './TaskForm';
import { useTranslation } from 'react-i18next';

interface TaskFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  task: Task | null;
  onSubmit: (data: CreateTaskData | UpdateTaskData) => Promise<void>;
  isSubmitting: boolean;
  initialData?: Partial<CreateTaskData>;
}

export const TaskFormModal = ({
  isOpen,
  onClose,
  task,
  onSubmit,
  isSubmitting,
  initialData = {},
}: TaskFormModalProps) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const { t } = useTranslation(['v0/tasks']);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent bg={bgColor} maxW={{ base: '95%', md: '800px' }}>
        <ModalHeader>{task ? t('v0/form.editTitle') : t('v0/form.createTitle')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <TaskForm
            task={task}
            onSubmit={async (data) => {
              await onSubmit(data);
              onClose();
            }}
            isSubmitting={isSubmitting}
            onCancel={onClose}
            initialData={initialData}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}; 